import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated, getCurrentUserRole } from "../services/auth";

const PrivateRoute = ({ element }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  const role = getCurrentUserRole();

  // admin and agent can access private routes; superadmin goes to /admin
  if (role !== "admin" && role !== "agent") {
    return <Navigate to="/" replace />;
  }

  return element;
};

export default PrivateRoute;
